import React from 'react';

import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import {reduxForm} from 'redux-form';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
require('../weightWizard.scss');

class EditWeightDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.dialogLabels = createLabelHelper('mat.dialog.');
    this.labels = createLabelHelper('mat.assetpage.weightWizard.');
  }


  getDialogButtons() {

    return {
      left: [
        {
          id:'cancel',
          text: this.dialogLabels.get('cancel'),
          action: this.onHide
        }
      ],
      right: [
        {
          id:'submit',
          text: this.props.isFetchWeightLoading ? this.labels.get('footer.inProgress') : this.labels.get('footer.ready'),
          bsStyle: 'primary',
          loading: this.props.isFetchWeightLoading,
          action: this.props.handleSubmit(this.goOn),
          disabled: this.props.isFetchWeightLoading
        }
      ]
    };
  }

  goOn = () => {
    this.props.actions.goOn();
  };

  onHide = () => {
    this.props.actions.onWizardClose();
    let wizardActions = this.props.wizardActions;
    wizardActions.close();
  };

  render() {
    let titleText = this.labels.get('header.title');
    let animation = this.props.isFirstLaunch;
    return (
      <Dialog
        animation={animation}
        id="edit-weight-dialog"
        className="weight-wizard"
        titleText={titleText}
        show={true}
        onHide={this.onHide}
        handleHashChange={false}
        footerButtons={this.getDialogButtons()}>


        <label className="body-title">{this.labels.get('firstStep.mainHeader')}</label>
        <label className="body-comment">{this.labels.get('firstStep.wait')}</label>

      </Dialog>
    );
  }
}
export default reduxForm({
    form: 'editWeightDialog',
  }
)(EditWeightDialog);


